/**
 * Configuração da Auth0, por ambiente.
 *
 * Existe para permitir apontar o dashboard para um tenant de desenvolvimento sem
 * editar código — antes disso, `domain`, `clientId` e `audience` estavam
 * hardcoded em seis pontos diferentes.
 *
 * ⚠️ `AUTH0_AUDIENCE` é também o NAMESPACE dos claims: a API lê
 * `<audience>/app_metadata` (`utils/rbac.js` na reviews-api) e o front faz o mesmo
 * em `_metronic/helpers/UserRoleHelpers.ts`. Mudar o audience por ambiente muda o
 * namespace, e aí a Action do tenant, a API e o front têm de concordar.
 *
 * Por isso a recomendação é **manter o audience idêntico nos dois tenants**. O
 * identifier de uma API na Auth0 é uma string arbitrária, de escopo do tenant — não
 * precisa ser única globalmente nem resolver em DNS, e a Auth0 nunca a chama. Dois
 * tenants podem declarar `https://reviews-api.konfidency.com.br` sem conflito.
 * Assim só `domain` e `clientId` variam entre dev e produção, e o namespace do
 * claim fica constante em todo lugar.
 *
 * Variáveis (CRA exige o prefixo REACT_APP_ e injeta em BUILD TIME — trocar de
 * tenant exige rebuild, não só restart):
 *   REACT_APP_AUTH0_DOMAIN     ex.: konfidency-dev.us.auth0.com
 *   REACT_APP_AUTH0_CLIENT_ID  client_id da SPA naquele tenant
 *   REACT_APP_AUTH0_AUDIENCE   só mexer com a ressalva acima em mente
 */

export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || 'konfidency.us.auth0.com'

export const AUTH0_CLIENT_ID =
  process.env.REACT_APP_AUTH0_CLIENT_ID || 'gNlboCgjC7I8rg4ofHmazO4C3jCTmE0M'

export const AUTH0_AUDIENCE =
  process.env.REACT_APP_AUTH0_AUDIENCE || 'https://reviews-api.konfidency.com.br'

/** Namespace do claim de autorização, derivado do audience. */
export const AUTH0_APP_METADATA_CLAIM = `${AUTH0_AUDIENCE}/app_metadata`
